import { useState } from "react";
import { CheckIcon, CopyIcon, MailIcon } from "lucide-react";

export const ShareArticleSection = () => {
  const [isCopied, setIsCopied] = useState(false);

  const url = typeof window !== "undefined" ? window.location.href : "";

  const params = new URLSearchParams(window.location.search);

  const caseTitle = params.get("case");
  const articleTitle = params.get("article");

  const title = articleTitle || caseTitle || "Check this out";

  const copyLink = () => {
    setIsCopied(true);
    navigator.clipboard.writeText(url);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  return (
    <div className="flex items-center mt-4">
      <p className="mr-6">Share</p>

      <button
        onClick={copyLink}
        className="flex items-center gap-x-2 font-semibold text-[#01c2f3] mr-6"
      >
        {isCopied ? (
          <>
            <CheckIcon /> Link copied!
          </>
        ) : (
          <>
            <CopyIcon /> Copy link
          </>
        )}
      </button>

      {/* Email */}
      <a
        href={`mailto:?subject=${encodeURIComponent(
          title,
        )}&body=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noreferrer"
        className="text-[#01c2f3]"
      >
        <MailIcon />
      </a>
      {/* LinkedIn */}
      {/* <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          url,
        )}`}
        target="_blank"
        rel="noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="ml-5"
        >
          <path
            d="M18.5236 0H1.47639C1.08483 0 0.709301 0.155548 0.432425 0.432425C0.155548 0.709301 0 1.08483 0 1.47639V18.5236C0 18.9152 0.155548 19.2907 0.432425 19.5676C0.709301 19.8445 1.08483 20 1.47639 20H18.5236C18.9152 20 19.2907 19.8445 19.5676 19.5676C19.8445 19.2907 20 18.9152 20 18.5236V1.47639C20 1.08483 19.8445 0.709301 19.5676 0.432425C19.2907 0.155548 18.9152 0 18.5236 0ZM5.96111 17.0375H2.95417V7.48611H5.96111V17.0375ZM4.45556 6.1625C4.11447 6.16058 3.7816 6.05766 3.49895 5.86674C3.21629 5.67582 2.99653 5.40544 2.8674 5.08974C2.73826 4.77404 2.70554 4.42716 2.77336 4.09288C2.84118 3.7586 3.0065 3.4519 3.24846 3.21148C3.49042 2.97107 3.79818 2.80772 4.13289 2.74205C4.4676 2.67638 4.81426 2.71133 5.12913 2.84249C5.44399 2.97365 5.71295 3.19514 5.90205 3.47901C6.09116 3.76288 6.19194 4.09641 6.19167 4.4375C6.19488 4.66586 6.15209 4.89253 6.06584 5.104C5.97959 5.31547 5.85165 5.50742 5.68964 5.66839C5.52763 5.82936 5.33487 5.95607 5.12285 6.04096C4.91083 6.12585 4.68389 6.16718 4.45556 6.1625ZM17.0444 17.0458H14.0389V11.8278C14.0389 10.2889 13.3847 9.81389 12.5403 9.81389C11.6486 9.81389 10.7736 10.4861 10.7736 11.8667V17.0458H7.76667V7.49306H10.6583V8.81667H10.6972C10.9875 8.22917 12.0042 7.225 13.5556 7.225C15.2333 7.225 17.0458 8.22083 17.0458 11.1375L17.0444 17.0458Z"
            fill="#01C2F3"
          />
        </svg>
      </a> */}
      {/* WhatsApp */}
      <a
        href={`https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`}
        target="_blank"
        rel="noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          className="ml-5"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.821 14.1211C15.58 14.8033 14.622 15.3677 13.858 15.5327C13.335 15.6437 12.653 15.7316 10.355 14.7793C7.774 13.71 4.19 9.90097 4.19 7.36621C4.19 6.07582 4.934 4.57324 6.235 4.57324C6.861 4.57324 6.999 4.58545 7.205 5.07959C7.446 5.66177 8.034 7.09612 8.104 7.24316C8.393 7.84634 7.80999 8.19945 7.38699 8.72461C7.25199 8.88265 7.099 9.05358 7.27 9.34766C7.44 9.63575 8.028 10.5941 8.892 11.3633C10.008 12.3576 10.913 12.675 11.237 12.8101C11.478 12.9101 11.766 12.8868 11.942 12.6987C12.165 12.4577 12.442 12.0577 12.724 11.6636C12.923 11.3815 13.176 11.3463 13.441 11.4463C13.62 11.5083 15.895 12.5648 15.991 12.7339C16.062 12.8569 16.062 13.4389 15.821 14.1211ZM10.002 0H9.99699C4.48399 0 0 4.48535 0 10C0 12.1867 0.705007 14.2153 1.90401 15.8608L0.658005 19.5767L4.50101 18.3486C6.08201 19.395 7.969 20 10.002 20C15.515 20 20 15.5147 20 10C20 4.48535 15.515 0 10.002 0Z"
            fill="#01C2F3"
          />
        </svg>
      </a>
    </div>
  );
};
